import gsap from 'gsap';

export default class ShowContent {
    constructor() {
        this.titles();
        this.contents();
    }

    titles() {
        const titles = document.querySelectorAll('section h2, #coachs .coach h3');
        Array.from(titles).forEach( title => {
            gsap.from(
                title,
                {
                    scrollTrigger: {
                        trigger: title,
                        start: 'top 75%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    y: 40,
                    opacity: 0
                }
            );
        });
    }

    contents() {
        const titles = document.querySelectorAll('#salle .text-container p, #salle .text-container ul, #salle .text-container ol, #coachs .coach .text-container');
        Array.from(titles).forEach( title => {
            gsap.from(
                title,
                {
                    scrollTrigger: {
                        trigger: title,
                        start: 'top 75%'
                    },
                    ease: "power4.out",
                    duration: 1.25,
                    y: 40,
                    opacity: 0,
                    delay: .2
                }
            );
        });
    }
}